<aca-alert-message></aca-alert-message>
<div [ngClass]="(!this.embedded)?'background':'embeddedBackground'">
    <router-outlet></router-outlet>
</div>
